import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, unref as _unref } from "vue"

const _hoisted_1 = { class: "module card-module labyrinth-module" }
const _hoisted_2 = { class: "content" }
const _hoisted_3 = { class: "screen" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", null, null, -1 /* HOISTED */)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "round-border" }, null, -1 /* HOISTED */)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "label" }, "UP", -1 /* HOISTED */)
const _hoisted_8 = [
  _hoisted_6,
  _hoisted_7
]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "round-border" }, null, -1 /* HOISTED */)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "label" }, "DOWN", -1 /* HOISTED */)
const _hoisted_11 = [
  _hoisted_9,
  _hoisted_10
]
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "round-border" }, null, -1 /* HOISTED */)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "label" }, "LEFT", -1 /* HOISTED */)
const _hoisted_14 = [
  _hoisted_12,
  _hoisted_13
]
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "round-border" }, null, -1 /* HOISTED */)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "label" }, "RIGHT", -1 /* HOISTED */)
const _hoisted_17 = [
  _hoisted_15,
  _hoisted_16
]

import "@style/modules/labyrinth.scss";
import ModuleStatusIndicator from "@src/components/ModuleStatusIndicator.vue";
import { ref } from "vue";
import LabyrinthPoint from "@src/modules/Labyrinth/structures/LabyrinthPoint";
import { LabyrinthDirection } from "@src/modules/Labyrinth/structures/LabyrinthEnums";
import defineModuleState, {
  ModuleEmits,
  ModuleProps,
} from "@src/composables/defineModuleState";
import Frame from "@src/components/Frame.vue";
import { getRandomGameLevel } from "@src/modules/Labyrinth/helpers/gameLevels";
import LabyrinthGame from "@src/modules/Labyrinth/structures/LabyrinthGame";
// import getWallConfiguration from "@src/modules/Labyrinth/helpers/wallsDefinition";
import defineDebugState from "@src/composables/defineDebugState";

const BLINK_INTERVAL_MS = 600;
const OBSTACLE_BLINK_INTERVAL_MS = 300;


export default /*#__PURE__*/_defineComponent({
  __name: 'LabyrinthModule',
  props: ModuleProps,
  emits: ModuleEmits,
  setup(__props, { emit }) {

const props = __props;



const state = defineModuleState(props, emit);
const debugState = defineDebugState();

state.onArmed(armModule);
state.onReady(restartModule);
state.onFailed(freezeModule);

const screen = ref<Array<boolean>>(
  Array.apply(null, Array(8 * 8)).map(() => false),
);
const currentPoint = ref<LabyrinthPoint>(new LabyrinthPoint(0, 0));
const endingPoint = ref<LabyrinthPoint>(new LabyrinthPoint(7, 6));
let blinkTimerId: number;
let obstacleBlinkTimerId: number;
let gameLevel: LabyrinthGame | null = null;
let currentGameLevel: number = 0;
const strikeNumber = ref<number>(0);

function armModule(): void {
  gameLevel = getRandomGameLevel(props.difficulty, props.serialNumber);
  if (gameLevel) {
    strikeNumber.value = 0;
    currentGameLevel = 0;
    currentPoint.value = gameLevel.startingPoint.getCopy();
    endingPoint.value = gameLevel
      .getLevel(currentGameLevel)
      .endingPoint.getCopy();

    screen.value[currentPoint.value.getArrayPosition()] = true;
    screen.value[endingPoint.value.getArrayPosition()] = true;
    startBlinking();
  }
}

function restartModule(): void {
  endBlinking();
  clearScreen();
}

function freezeModule(): void {}

function move(direction: LabyrinthDirection): void {
  if (!state.isArmed.value || state.isFailed.value) {
    return;
  }
  if (!gameLevel?.walls?.canCross(direction, currentPoint.value)) {
    failModule();
    return;
  }

  screen.value[currentPoint.value.getArrayPosition()] = false;

  switch (direction) {
    case LabyrinthDirection.UP:
      if (currentPoint.value.y > 0) {
        currentPoint.value.y--;
      }
      break;
    case LabyrinthDirection.DOWN:
      if (currentPoint.value.y < 7) {
        currentPoint.value.y++;
      }
      break;
    case LabyrinthDirection.LEFT:
      if (currentPoint.value.x > 0) {
        currentPoint.value.x--;
      }
      break;
    case LabyrinthDirection.RIGHT:
      if (currentPoint.value.x < 7) {
        currentPoint.value.x++;
      }
      break;
  }

  if (gameLevel?.getLevel(currentGameLevel).isObstacle(currentPoint.value)) {
    failModule();
    return;
  }

  screen.value[currentPoint.value.getArrayPosition()] = true;

  checkSolved();
}

function failModule(): void {
  strikeNumber.value++;
  if (strikeNumber.value > 2) {
    state.emitFailed();
    endBlinking();
    clearScreen();
  } else if (gameLevel) {
    screen.value[currentPoint.value.getArrayPosition()] = false;
    currentPoint.value = gameLevel.startingPoint.getCopy();
    screen.value[currentPoint.value.getArrayPosition()] = true;
  }
}

function checkSolved(): void {
  const isLastLevel = gameLevel?.getLevelCount() === currentGameLevel + 1;

  if (endingPoint.value.isEqual(currentPoint.value)) {
    if (isLastLevel) {
      endBlinking();
      clearScreen();
      state.emitDisarmed();
    } else if (gameLevel) {
      clearScreen();
      currentPoint.value = gameLevel
        .getLevel(currentGameLevel)
        .endingPoint.getCopy();
      currentGameLevel++;
      endingPoint.value = gameLevel
        .getLevel(currentGameLevel)
        .endingPoint.getCopy();
      screen.value[currentPoint.value.getArrayPosition()] = true;
      screen.value[endingPoint.value.getArrayPosition()] = true;
    }
  }
}

function clearScreen(): void {
  screen.value = Array.apply(null, Array(8 * 8)).map(() => false);
}

function endBlinking(): void {
  clearInterval(blinkTimerId);
  clearInterval(obstacleBlinkTimerId);
}

function startBlinking(): void {
  endBlinking();

  blinkTimerId = <number>(<unknown>setInterval(() => {
    let pos = endingPoint.value.getArrayPosition();
    screen.value[pos] = !screen.value[pos];
  }, BLINK_INTERVAL_MS));

  obstacleBlinkTimerId = <number>(<unknown>setInterval(() => {
    if (gameLevel) {
      for (const obstacle of gameLevel?.getLevel(currentGameLevel).obstacles) {
        let pos = obstacle.getArrayPosition();
        screen.value[pos] = !screen.value[pos];
      }
    }
  }, OBSTACLE_BLINK_INTERVAL_MS));
}

function getPointClass(state: boolean, index: number): Array<string> {
  const classes = [];

  if (debugState.isDebugModeEnabled.value && gameLevel?.walls) {
    classes.push("w-" + gameLevel?.walls.matrix[index]);
  }

  if (state) {
    classes.push("active");
  }

  return classes;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(Frame, {
        top: 35,
        left: 75,
        height: 230,
        width: 230,
        text: "MATRIX",
        radius: "8px"
      }),
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(screen.value, (state, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: _normalizeClass(["point", getPointClass(state, index)])
          }, _hoisted_5, 2 /* CLASS */))
        }), 256 /* UNKEYED_FRAGMENT */))
      ]),
      _createElementVNode("div", {
        class: "button up",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (move(_unref(LabyrinthDirection).UP)))
      }, _hoisted_8),
      _createElementVNode("div", {
        class: "button down",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (move(_unref(LabyrinthDirection).DOWN)))
      }, _hoisted_11),
      _createElementVNode("div", {
        class: "button left",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (move(_unref(LabyrinthDirection).LEFT)))
      }, _hoisted_14),
      _createElementVNode("div", {
        class: "button right",
        onClick: _cache[3] || (_cache[3] = ($event: any) => (move(_unref(LabyrinthDirection).RIGHT)))
      }, _hoisted_17)
    ]),
    _createVNode(ModuleStatusIndicator, {
      "is-armed": _unref(state).isArmed.value,
      "is-disarmed": _unref(state).isDisarmed.value,
      "strike-number": strikeNumber.value
    }, null, 8 /* PROPS */, ["is-armed", "is-disarmed", "strike-number"])
  ]))
}
}

})